<template>
  <div>
    <div id="editor" class="editor" ref="editor"></div>
  </div>
</template>
<script>
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import E from 'wangeditor'
import COS from 'cos-js-sdk-v5'
import hljs from 'highlight.js'
import { uploadAvatar, ossSignature, ossSigkey } from '@/api/system/user'
import moment from 'moment'
import UploadFileToOSS from '@/utils/upload-file-to-oss.js'
export default {
  name: 'Editor',
  components: {},
  props: {
    /* 编辑器的内容 */
    value: {
      type: String,
      default: '',
    },
    /* 高度 */
    height: {
      type: Number,
      default: null,
    },
    /* 只读 */
    readOnly: {
      type: Boolean,
      default: false,
    },
    // 上传文件大小限制(MB)
    fileSize: {
      type: Number,
      default: 1024,
    },
    imageSize: {
      type: Number,
      default: 5,
    },
    videoSize: {
      type: Number,
      default: 1024,
    },
  },
  data() {
    return {
      uploadImgUrl: process.env.VUE_APP_BASE_API + '/common/local/file/upload',
      headers: {
        Authorization: 'Bearer ' + storage.get(ACCESS_TOKEN),
        Accept: 'application/json, text/plain, */*',
      },
      editor: null,
      currentValue: '',
    }
  },
  computed: {},
  watch: {
    value: {
      handler(val) {
        if (val !== this.currentValue) {
          this.currentValue = val === null ? '' : val
          if (this.editor) {
            this.editor.txt.html(this.currentValue)
          }
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    // 获取文件名称
    generateCosKey(name, ext) {
      var ymd = moment().format('YYYYMMDD')
      var ymd = moment().format('YYYYMMDD_HHmmss_')
      var r = ('000000' + Math.random() * 1000000).slice(-6)
      var cosKey = name + `/IMG_${ymd}_${r}.${ext}`
      return cosKey
    },
    init() {
      var that = this
      this.editor = new E('#editor')
      // 代码高亮
      this.editor.highlight = hljs
      // 高度设置
      if (this.height) {
        this.editor.config.height = this.height
      }
      // z-index
      this.editor.config.zIndex = 0
      // 自定义提示信息
      this.editor.config.customAlert = function (s, t) {
        switch (t) {
          case 'success':
            that.$message.success(s)
            break
          case 'info':
            that.$message.info(s)
            break
          case 'warning':
            that.$message.warning(s)
            break
          case 'error':
            that.$message.error(s)
            break
          default:
            that.$message.info(s)
            break
        }
      }
      // 图片
      this.editor.config.uploadImgMaxSize = 1024 * 1024 * this.imageSize
      this.editor.config.uploadFileName = 'file'
      // this.editor.config.uploadImgServer = this.uploadImgUrl
      // this.editor.config.uploadImgHeaders = this.headers
      // this.editor.config.uploadImgHooks = {
      //   customInsert: function (insertImgFn, result) {
      //     // insertImgFn 可把图片插入到编辑器，传入图片 src ，执行函数即可
      //     insertImgFn(result.url)
      //   }
      // }
      this.editor.config.customUploadImg = async (files, insert) => {
        console.log(files, 'resresres====')
        const file = files[0]
        var lastIndex = file.name.lastIndexOf('.')
        console.log('选择的图片路径fileName', lastIndex)
        var extName = lastIndex > -1 ? file.name.slice(lastIndex + 1) : ''
        console.log(extName, 'extNameextNameextName')
        const cosKey = this.generateCosKey(this.$cosUrl, extName)
        const fileNames = cosKey.split('/').pop()
        console.log(fileNames, 'fileNamesfileNamesfileNames')
        ossSignature().then((res) => {
          res = res.data
          const cos = new COS({
            SecretId: res.tmpSecretId,
            SecretKey: res.tmpSecretKey,
            SecurityToken: res.sessionToken, // sts服务下发的临时 SessionToken
            StartTime: res.startTime, // 建议传入服务端时间，可避免客户端时间不准导致的签名错误
            ExpiredTime: res.expiredTime, // 临时密钥过期时间
          })
          // const PicOperations = JSON.stringify({
          //   is_pic_info: 1, // 是否返回原图信息
          //   rules: [
          //     {
          //       fileid: 'desample_photo.jpg', // 处理后的文件名
          //       rule: 'imageMogr2/format/avif', // 图片处理规则
          //     },
          //   ],
          // })
          // const PicOperations = JSON.stringify({
          //   is_pic_info: 1, // 返回图片信息
          //   rules: [
          //     {
          //       fileid: cosKey, // 压缩后的文件名
          //       rule: 'imageSlim', // 启用极智压缩
          //     },
          //   ],
          // })
          const headers = {
            // 通过 imageMogr2 接口进行 jpg 压缩
            'Pic-Operations': JSON.stringify({
              is_pic_info: 1, // 返回图片信息
              rules: [
                {
                  fileid: cosKey, // 压缩后的文件名
                  rule: 'imageMogr2/quality/33', // 启用极智压缩
                },
              ],
            }),
          }
          console.log(this.$Bucket, 'this.$Bucketthis.$Bucket')
          // const obj = {
          //   Bucket: this.$Bucket, // 对象存储桶名称
          //   Region: 'ap-beijing', // 地域
          //   Key: cosKey, // 文件路径
          //   Body: file, // 文件对象
          //   Headers: headers,
          //   SliceSize:
          //     1024 * 1024 * 5 /* 触发分块上传的阈值，超过5MB使用分块上传，小于5MB使用简单上传。可自行设置，非必须 */,
          //   onProgress: function (progressData) {},
          // }
          const obj = {
            Bucket: this.$Bucket, // 对象存储桶名称
            Region: 'ap-beijing', // 地域
            Key: cosKey, // 文件路径
            Body: file, // 文件对象
            SliceSize:
              1024 * 1024 * 5 /* 触发分块上传的阈值，超过5MB使用分块上传，小于5MB使用简单上传。可自行设置，非必须 */,
            onProgress: function (progressData) {},
          }
          if (this.type !== 'video') {
            obj.Headers = headers
          }
          console.log(obj, 'objobjobj')
          cos.putObject(obj, function (err, data) {
            // console.log(data, 'datadatadatac测试数据信心====')
            if (err) {
              console.log('上传失败', err)
            } else {
              console.log('上传成功55555')
              // that.handleOk(cosKey)
              insert(that.$url + cosKey)
            }
          })
        })
        // new UploadFileToOSS(files, {
        //   finally: (res) => {
        //     insert(res[0].url);
        //   },
        // });
        // ossSignature()
        // this.$message.success('上传成功')
      }
      // 视频
      this.editor.config.uploadVideoMaxSize = 1024 * 1024 * this.videoSize
      this.editor.config.uploadVideoName = 'file'
      // this.editor.config.uploadVideoServer = this.uploadImgUrl
      // this.editor.config.uploadVideoHeaders = this.headers
      // this.editor.config.uploadVideoHooks = {
      //   customInsert: function (insertVideoFn, result) {
      //     // insertImgFn 可把图片插入到编辑器，传入图片 src ，执行函数即可
      //     insertVideoFn(result.url)
      //   }
      // }
      this.editor.config.customUploadVideo = async (files, insert) => {
        const file = files[0]
        var lastIndex = file.name.lastIndexOf('.')
        console.log('选择的图片路径fileName', lastIndex)
        var extName = lastIndex > -1 ? file.name.slice(lastIndex + 1) : ''
        console.log(extName, 'extNameextNameextName')
        const cosKey = this.generateCosKey(this.$cosUrl, extName)
        const fileNames = cosKey.split('/').pop()
        console.log(fileNames, 'fileNamesfileNamesfileNames')
        ossSignature().then((res) => {
          res = res.data
          const cos = new COS({
            SecretId: res.tmpSecretId,
            SecretKey: res.tmpSecretKey,
            SecurityToken: res.sessionToken, // sts服务下发的临时 SessionToken
            StartTime: res.startTime, // 建议传入服务端时间，可避免客户端时间不准导致的签名错误
            ExpiredTime: res.expiredTime, // 临时密钥过期时间
          })
          // const PicOperations = JSON.stringify({
          //   is_pic_info: 1, // 是否返回原图信息
          //   rules: [
          //     {
          //       fileid: 'desample_photo.jpg', // 处理后的文件名
          //       rule: 'imageMogr2/format/avif', // 图片处理规则
          //     },
          //   ],
          // })
          // const PicOperations = JSON.stringify({
          //   is_pic_info: 1, // 返回图片信息
          //   rules: [
          //     {
          //       fileid: cosKey, // 压缩后的文件名
          //       rule: 'imageSlim', // 启用极智压缩
          //     },
          //   ],
          // })
          const headers = {
            // 通过 imageMogr2 接口进行 jpg 压缩
            'Pic-Operations': JSON.stringify({
              is_pic_info: 1, // 返回图片信息
              rules: [
                {
                  fileid: cosKey, // 压缩后的文件名
                  rule: 'imageMogr2/quality/33', // 启用极智压缩
                },
              ],
            }),
          }
          console.log(this.$Bucket, 'this.$Bucketthis.$Bucket')
          // const obj = {
          //   Bucket: this.$Bucket, // 对象存储桶名称
          //   Region: 'ap-beijing', // 地域
          //   Key: cosKey, // 文件路径
          //   Body: file, // 文件对象
          //   Headers: headers,
          //   SliceSize:
          //     1024 * 1024 * 5 /* 触发分块上传的阈值，超过5MB使用分块上传，小于5MB使用简单上传。可自行设置，非必须 */,
          //   onProgress: function (progressData) {},
          // }
          const obj = {
            Bucket: this.$Bucket, // 对象存储桶名称
            Region: 'ap-beijing', // 地域
            Key: cosKey, // 文件路径
            Body: file, // 文件对象
            SliceSize:
              1024 * 1024 * 5 /* 触发分块上传的阈值，超过5MB使用分块上传，小于5MB使用简单上传。可自行设置，非必须 */,
            onProgress: function (progressData) {},
          }
          if (this.type !== 'video') {
            obj.Headers = headers
          }
          console.log(obj, 'objobjobj')
          cos.putObject(obj, function (err, data) {
            // console.log(data, 'datadatadatac测试数据信心====')
            if (err) {
              console.log('上传失败', err)
            } else {
              console.log('上传成功55555')
              // that.handleOk(cosKey)
              insert(that.$url + cosKey)
            }
          })
        })
        this.$message.success('上传成功')
      }
      // 数据双向绑定
      this.editor.config.onchange = function (newHtml) {
        that.currentValue = newHtml
        that.$emit('input', newHtml)
      }
      this.editor.create()
      this.editor.txt.html(this.currentValue)
      if (this.readOnly) {
        this.editor.disable()
      }
    },
    handleUploadError() {
      this.$message.error('图片插入失败')
    },
  },
}
</script>

<style>
</style>
